 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ActiveSessions~Categories~ChangePassword~CourseDetails~Courses~EmployeeProfile~EmployeesRoles~Forgot~8e370b74":"ActiveSessions~Categories~ChangePassword~CourseDetails~Courses~EmployeeProfile~EmployeesRoles~Forgot~8e370b74","ActiveSessions~LoginAudit":"ActiveSessions~LoginAudit","ActiveSessions":"ActiveSessions","LoginAudit":"LoginAudit","Categories~ChangePassword~CourseDetails~EmployeeProfile~EmployeesRoles~ForgotPassword~Invoices~Organ~67d683e1":"Categories~ChangePassword~CourseDetails~EmployeeProfile~EmployeesRoles~ForgotPassword~Invoices~Organ~67d683e1","Categories~CourseDetails~Organizations~QuizDetails":"Categories~CourseDetails~Organizations~QuizDetails","Categories":"Categories","Certificates~Courses~EmployeeProfile~Home~Invoices~Notifications~OrganizationProfile~Registration~Re~3c161403":"Certificates~Courses~EmployeeProfile~Home~Invoices~Notifications~OrganizationProfile~Registration~Re~3c161403","Certificates~Invoices":"Certificates~Invoices","Invoices":"Invoices","CourseDetails~EmployeeProfile~EmployeesRoles~OrganizationProfile~Organizations~QuizDetails~Registrat~17943df9":"CourseDetails~EmployeeProfile~EmployeesRoles~OrganizationProfile~Organizations~QuizDetails~Registrat~17943df9","EmployeeProfile":"EmployeeProfile","OrganizationProfile":"OrganizationProfile","Registration":"Registration","Settings":"Settings","ChangePassword":"ChangePassword","CourseDetails":"CourseDetails","Organizations":"Organizations","Certificates~Courses~EmployeesRoles~Registrations~Reports":"Certificates~Courses~EmployeesRoles~Registrations~Reports","EmployeesRoles":"EmployeesRoles","ForgotPassword":"ForgotPassword","SignIn":"SignIn","Courses~Home~Registrations":"Courses~Home~Registrations","Courses":"Courses","Registrations":"Registrations","Reports":"Reports","Home":"Home","QuizDetails~Quizzes":"QuizDetails~Quizzes","QuizDetails":"QuizDetails","Quizzes":"Quizzes","Certificates":"Certificates","Notifications":"Notifications"}[chunkId]||chunkId) + "." + {"ActiveSessions~Categories~ChangePassword~CourseDetails~Courses~EmployeeProfile~EmployeesRoles~Forgot~8e370b74":"60c4a517","ActiveSessions~LoginAudit":"6049690b","ActiveSessions":"6ea47627","LoginAudit":"8f5e25cf","Categories~ChangePassword~CourseDetails~EmployeeProfile~EmployeesRoles~ForgotPassword~Invoices~Organ~67d683e1":"ac04567e","Categories~CourseDetails~Organizations~QuizDetails":"5850d57a","Categories":"85fc6811","Certificates~Courses~EmployeeProfile~Home~Invoices~Notifications~OrganizationProfile~Registration~Re~3c161403":"10856a61","Certificates~Invoices":"8c741de5","Invoices":"47eefb08","CourseDetails~EmployeeProfile~EmployeesRoles~OrganizationProfile~Organizations~QuizDetails~Registrat~17943df9":"3fcf5056","EmployeeProfile":"45f12241","OrganizationProfile":"c671bcf2","Registration":"d3c88595","Settings":"d49b3df0","ChangePassword":"65a3d87d","CourseDetails":"6ecd7876","Organizations":"34001560","Certificates~Courses~EmployeesRoles~Registrations~Reports":"9fafddbf","EmployeesRoles":"1dce2773","ForgotPassword":"7cbd5b73","SignIn":"d968bbad","Courses~Home~Registrations":"4346851e","Courses":"2a57280c","Registrations":"438da02a","Reports":"14cec2fb","Home":"4426b3a6","QuizDetails~Quizzes":"ecb2d788","QuizDetails":"7656d71d","Quizzes":"86c437e4","Certificates":"7980f826","Notifications":"a88612a9","chunk-2d216214":"a9f4880f","chunk-2d216257":"1caeb235","chunk-45d4c016":"5b42da94"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ActiveSessions~Categories~ChangePassword~CourseDetails~Courses~EmployeeProfile~EmployeesRoles~Forgot~8e370b74":1,"ActiveSessions~LoginAudit":1,"ActiveSessions":1,"LoginAudit":1,"Categories~CourseDetails~Organizations~QuizDetails":1,"Categories":1,"Certificates~Courses~EmployeeProfile~Home~Invoices~Notifications~OrganizationProfile~Registration~Re~3c161403":1,"Certificates~Invoices":1,"Invoices":1,"CourseDetails~EmployeeProfile~EmployeesRoles~OrganizationProfile~Organizations~QuizDetails~Registrat~17943df9":1,"EmployeeProfile":1,"OrganizationProfile":1,"Registration":1,"Settings":1,"CourseDetails":1,"Organizations":1,"Certificates~Courses~EmployeesRoles~Registrations~Reports":1,"EmployeesRoles":1,"Courses~Home~Registrations":1,"Courses":1,"Registrations":1,"Reports":1,"Home":1,"QuizDetails":1,"Quizzes":1,"Certificates":1,"Notifications":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ActiveSessions~Categories~ChangePassword~CourseDetails~Courses~EmployeeProfile~EmployeesRoles~Forgot~8e370b74":"ActiveSessions~Categories~ChangePassword~CourseDetails~Courses~EmployeeProfile~EmployeesRoles~Forgot~8e370b74","ActiveSessions~LoginAudit":"ActiveSessions~LoginAudit","ActiveSessions":"ActiveSessions","LoginAudit":"LoginAudit","Categories~ChangePassword~CourseDetails~EmployeeProfile~EmployeesRoles~ForgotPassword~Invoices~Organ~67d683e1":"Categories~ChangePassword~CourseDetails~EmployeeProfile~EmployeesRoles~ForgotPassword~Invoices~Organ~67d683e1","Categories~CourseDetails~Organizations~QuizDetails":"Categories~CourseDetails~Organizations~QuizDetails","Categories":"Categories","Certificates~Courses~EmployeeProfile~Home~Invoices~Notifications~OrganizationProfile~Registration~Re~3c161403":"Certificates~Courses~EmployeeProfile~Home~Invoices~Notifications~OrganizationProfile~Registration~Re~3c161403","Certificates~Invoices":"Certificates~Invoices","Invoices":"Invoices","CourseDetails~EmployeeProfile~EmployeesRoles~OrganizationProfile~Organizations~QuizDetails~Registrat~17943df9":"CourseDetails~EmployeeProfile~EmployeesRoles~OrganizationProfile~Organizations~QuizDetails~Registrat~17943df9","EmployeeProfile":"EmployeeProfile","OrganizationProfile":"OrganizationProfile","Registration":"Registration","Settings":"Settings","ChangePassword":"ChangePassword","CourseDetails":"CourseDetails","Organizations":"Organizations","Certificates~Courses~EmployeesRoles~Registrations~Reports":"Certificates~Courses~EmployeesRoles~Registrations~Reports","EmployeesRoles":"EmployeesRoles","ForgotPassword":"ForgotPassword","SignIn":"SignIn","Courses~Home~Registrations":"Courses~Home~Registrations","Courses":"Courses","Registrations":"Registrations","Reports":"Reports","Home":"Home","QuizDetails~Quizzes":"QuizDetails~Quizzes","QuizDetails":"QuizDetails","Quizzes":"Quizzes","Certificates":"Certificates","Notifications":"Notifications"}[chunkId]||chunkId) + "." + {"ActiveSessions~Categories~ChangePassword~CourseDetails~Courses~EmployeeProfile~EmployeesRoles~Forgot~8e370b74":"15290f63","ActiveSessions~LoginAudit":"6c80058b","ActiveSessions":"15fae48a","LoginAudit":"b9ee2a04","Categories~ChangePassword~CourseDetails~EmployeeProfile~EmployeesRoles~ForgotPassword~Invoices~Organ~67d683e1":"31d6cfe0","Categories~CourseDetails~Organizations~QuizDetails":"9ab52e6a","Categories":"4d6a6e72","Certificates~Courses~EmployeeProfile~Home~Invoices~Notifications~OrganizationProfile~Registration~Re~3c161403":"2090ba31","Certificates~Invoices":"7acd574e","Invoices":"757413d2","CourseDetails~EmployeeProfile~EmployeesRoles~OrganizationProfile~Organizations~QuizDetails~Registrat~17943df9":"ea7e0597","EmployeeProfile":"0bd353e0","OrganizationProfile":"5bcde8e7","Registration":"eec0a85a","Settings":"aa186c0f","ChangePassword":"31d6cfe0","CourseDetails":"a2bf6dde","Organizations":"951c3670","Certificates~Courses~EmployeesRoles~Registrations~Reports":"49830f27","EmployeesRoles":"791dacba","ForgotPassword":"31d6cfe0","SignIn":"31d6cfe0","Courses~Home~Registrations":"b75bf511","Courses":"21459dcf","Registrations":"f023df4c","Reports":"217cc857","Home":"c5307885","QuizDetails~Quizzes":"31d6cfe0","QuizDetails":"89cd129a","Quizzes":"f023df4c","Certificates":"11ce0f27","Notifications":"2899d428","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-45d4c016":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
